import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import SearchBar from "../../components/searchbar/SearchBar";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import ViewClientTaskDatatable from "./components/ViewClientTaskDatatable";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllClients } from "../../redux/actions/authActions";

const ViewClientTask = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");

  const clients = useSelector((state) => state.auth.allClients);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token && (!clients || clients.length === 0)) {
      dispatch(getAllClients(token));
    }
  }, [dispatch, token, clients]);

  const client = Array.isArray(clients) ? clients.find((c) => c._id === clientId) : null;
  const companyName = client?.businessName || client?.name || "Client Tasks";
  const spocName = client?.name && client?.businessName ? ` • SPOC: ${client.name}` : "";
  const clientTitle = `${companyName}${spocName}`;

  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title={clientTitle} />
        <SearchBar
          titleOne="Create Task"
          addClientPath="create-task"
          showEditButton={false} // Hide the Sort button
          showAddButton={true} // The button will be shown
        />
        <DatatableSection>
          <ViewClientTaskDatatable />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default ViewClientTask;
